import { Component, OnInit, Input } from '@angular/core';
import { AfterViewInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ProductionJobCreationComponent } from '../production-job-creation/production-job-creation.component'
import { CreateProductionJobComponent } from '../../production/create-production-job/create-production-job.component';
import { APIService } from '../../api.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { JobDetailsComponent } from '../job-details/job-details.component'
import { Action } from 'rxjs/internal/scheduler/Action';
import { CommonService } from '../../services/common.service';
import { viewClassName } from '@angular/compiler';
import { ItemEntryComponent } from 'src/app/inventory/item-entry/item-entry.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { threadId } from 'worker_threads';
import { DataService } from '../../services/data.service'
import { ActivatedRoute, Router } from '@angular/router';
import { ModuleTrainingComponent } from '../../module-training/module-training.component';

// import 'rxjs/add/operator/filter';


@Component({
  selector: 'app-production-list',
  templateUrl: './production-list.component.html',
  styleUrls: ['./production-list.component.scss']
})
export class ProductionListComponent implements AfterViewInit, OnInit {

  @Input() mdlRef: any;
  //@ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  displayedColumns: string[] = ['JobNo', 'ProductName', 'ProductCode', 'CstrRelName', 'LaunchDT', 'TargetDT',
  'Stage','Qty', 'SKU',  'Action'];

  displayedProjectColumns: string[] = ['JobNo', 'ProductName', 'ProductCode', 'CstrRelName', 'LaunchDT', 'TargetDT',
  'Stage', 'Action'];

  getCurrURL: string = '';
  dataSource: any = [];
  jarvisData: any = [];
  agencyData: any = [];
  ProductList: any = [];
  Items: any = [];
  tempProdList: any = [];
  WipCnt: any = 0;
  overDueCnt: any = 0;
  TotalJob: any = 0;
  oldestJob: any = '';
  maxLoad: any = '';
  statusID: number = 1;
  // filter: number = 0;
  isShow: boolean = false;
  isWeb: boolean = true;
  curDate: any = new Date();
  period: any = 1;
  months: any = [];
  month: any;
  year: any;
  yearList: any = [];
  selectedMonthName: any;
  view = {
    month: this.curDate.getMonth() + 1,
    year: this.curDate.getFullYear()
  }
  exportToExcel: any = [];
  search: string = '';
  isAdmin: boolean = false;
  isShowProduct: boolean = false;
  prTypeID: number = 1;
  rights: any;
  showLearningMaterial: boolean = false;
  showOnBoarding: boolean = false;
  activeProdListCnt = 0;
  billables: any;
  showSearchBar: boolean = false;
  // isFromProjectMod: boolean = false;

  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
      , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

    return function (table: any, name: string, fileName: any) {
      if (!table.nodeType) table = table
      var ctx = { worksheet: name || 'Worksheet', table: table }
      //window.location.href = uri + base64(format(template, ctx))
      var link = document.createElement("a");
      link.download = fileName || 'download.xls';
      link.href = uri + base64(format(template, ctx));
      link.click();
    }
  })()

  today = new Date();

  constructor(private modalService: NgbModal, private apiService: APIService,public commonFun: CommonService, private commonSer: CommonService,private SpinnerService: NgxSpinnerService, private dataSer: DataService, private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit(): void {
    //  alert("This feature is under development expected release in April 2021.");

    let getParam =  this.commonFun.GetParam("p");
    
    let erpCount = this.apiService.getCookie('ERP_Cnts');
    let erpCountData = [];
    if (erpCount) {
      erpCountData = JSON.parse(erpCount);
      if (erpCountData.length > 0) {
        this.activeProdListCnt = (getParam == 1 ? erpCountData[0].CntActiveJobs : erpCountData[0].CntActiveProjects);
      }
    }
    
    if(getParam == 2){
     this.prTypeID = 2;
     this.apiService.setCookie("prTypeID", "2");
    }
    else{
      this.prTypeID = 1;
      this.apiService.setCookie("prTypeID", "1");
    }
    
    if(this.prTypeID == 1){
      this.displayedColumns = this.displayedColumns;
    }
    else{
      this.displayedColumns = this.displayedProjectColumns;
    }
    
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      var PremiumTillDT = this.agencyData[0].PremiumTillDT;
      // if (new Date(PremiumTillDT) < new Date() || !PremiumTillDT || PremiumTillDT == null) {
      //   window.location.href = "main.html#/home";
      //   return;
      // }
      if (this.apiService.checkIsPremiumOrTrial() == false){
        if (this.apiService.fn_isLiveURL() == true)
        {
          window.location.href = "https://biziverse.com/main.html#/home";
          return;
        }
        else{
          window.location.href = "main.html#/home";
          return;
        }    
      }
    }

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    
    if (this.agencyData.length > 0 && this.jarvisData.length > 0) {
      this.isAdmin = (this.agencyData[0].AdminUserID == this.jarvisData[0].UserID) ? true : false;
    }

    let jData = this.apiService.getCookie("J");
      if(jData){
        let userRigths = JSON.parse(jData);
        let ownUserID: number = this.jarvisData[0].UserID;
        if(userRigths.length > 0){
          this.rights = $.grep(userRigths, function(o: any){ return o.UserID == ownUserID })[0];
        }       
      }
    
    this.isWeb = this.apiService.apiCheckWeb();
    this.showLearningMaterial = this.commonSer.checkShowLearningMaterial();
    this.showOnBoarding = this.commonSer.checkShowOnBoarding();

    this.apiService.getIDB('erp_inv', (tempItems: any) => {
      if (tempItems && tempItems.length > 0) {
        this.Items = tempItems;
      }
      else {
        this.apiService.fetchERPStockItems('', (res: any) => {});
        let billables = [];
          let cfgAgnCookie = this.apiService.getCookie('Cfg_AgnCfg');
          if (cfgAgnCookie) {
              let cfgAgnData = JSON.parse(cfgAgnCookie);
              if (cfgAgnData.length > 0) {
                  let blbJSON = cfgAgnData[0]?.Billables ? cfgAgnData[0].Billables : '[]';
                  billables = JSON.parse(blbJSON);
              }
          }
          this.Items = billables
              .filter((b: any) => b?.IID && b.IID > 0 && b.INm && b.IsA && (b.TID == 1 || b.TID == 4))
              .map((item: any) => {return {
                ItemID: item.IID,
                ItemName: item.INm,
                ItemCode: item?.ICd ? item?.ICd : '',
                DefSaleRate: item.SRT ? item.SRT : 0,
                TypeID: item.TID,
                SKU: item.Unit,
          }})
      }
    });

    let cfg_AgnCfg : any = localStorage.getItem("Cfg_AgnCfg");
    if (cfg_AgnCfg) {
        cfg_AgnCfg = JSON.parse(cfg_AgnCfg);
        if (cfg_AgnCfg && cfg_AgnCfg.length > 0) {
          this.billables = cfg_AgnCfg[0];
          this.billables = this.billables.Billables; 
          this.billables = JSON.parse(this.billables);
        }
    }

    //year and months periods
    // this.year = this.curDate.getFullYear();
    // this.month = this.curDate.getMonth() + 1;
    this.getPeriodData();

    let selecetdYear = this.months[this.months.length - 1];
    if(selecetdYear.length > 0){
      this.month = selecetdYear[0].number;
      this.year = selecetdYear[0].year;
    }
    else{
       this.year = this.curDate.getFullYear();
       this.month = this.curDate.getMonth() + 1;
    }

    this.isShowProduct = this.apiService.checkFeatureAccess('ProductionList');
    if (!this.isShowProduct) {
      window.location.href = "https://biziverse.com/main.html#/home";
    }

    let sendData = {'prTypeID': this.prTypeID}
    this.dataSer.updateProjectData(sendData)
    
    this.getData();

    let oParam = this.commonFun.GetParam("o");
    if (this.prTypeID == 2 && oParam) {
      setTimeout(() => {
        this.open(null);
      }, 500);
    }
  }



  ngAfterViewInit(): void {
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }

  closeResult: any;
  modalReference: any;

  open(content: any) {
    if (this.prTypeID == 1) {
      this.modalReference = this.modalService.open(ProductionJobCreationComponent, { windowClass: 'productionEntry', backdrop: 'static', keyboard: false });
      this.modalReference.componentInstance.mdlRef = this.modalReference;
      this.modalReference.componentInstance.prTypeID = this.prTypeID;

      this.modalReference.result.then((result: any) => {

        if (result.action == 'Done') {
          this.getWIPNos();
          let Wip = JSON.parse(result.obj.updatePackage);

          this.Edit("", Wip.Table[0].JobID);

        }
      })    
    }
    else {
      this.modalReference = this.modalService.open(CreateProductionJobComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'my-class', backdrop: 'static', keyboard: false });
      this.modalReference.componentInstance.mdlRef = this.modalReference;
      this.modalReference.componentInstance.prTypeID = this.prTypeID;

      this.modalReference.result.then((result: any) => {
        if (result && result.action == 'Done') {
          this.getWIPNos();
          let Wip = JSON.parse(result.obj.updatePackage);

          this.Edit("", Wip.Table[0].JobID);
        }
      })
    }
    
  }

  Edit(content: any, obj: any) {
    // this.ItemID = obj
    this.modalReference = this.modalService.open(JobDetailsComponent, { windowClass: 'modal-item-Edit', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.Data = obj;
    this.modalReference.componentInstance.prTypeID = this.prTypeID;

    this.modalReference.result.then((result: any) => {
      if (result.action == 'Done') {
        this.getWIPNos();
      }
    })
  }

  getWIPNos() {
    //this.WIPNos = ['001', '002', '003', '004', '005', '006', '007', '008', '009', '010'];
    let data = [{
      statusID: this.statusID,
      month: this.month || "0",
      year: this.year || "0",
      jobTypeID : this.prTypeID
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'getPrdJobs',
      moduleID: 8,
      data: JSON.stringify(data)
    }];
    // this.SpinnerService.show();
    this.apiService.getData(myParams, this.successConfigResp.bind(this), this.failureResp.bind(this));
  }

  //successConfigResp - success  get handler
  successConfigResp(res: any) {
    
    // this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          this.ProductList = [];
          let cData = reponseData.Table1;
          let tnxnData = reponseData.Table2 ? reponseData.Table2 : [];

          let tempPrdList = cData.filter((a: any) => a.JobTypeID == 1);
          if (this.prTypeID == 1 && tempPrdList.length > 0) {
            let tempCntWip = tempPrdList.filter((x: any) => x.StageID > 0)
            let unique = [...new Set(tempCntWip.map((propYoureChecking: any) => propYoureChecking.Stage))];
            let tempOverDueCnt = tempPrdList.filter((x: any) => new Date(x.TargetDT) < new Date())

            let oldestSort = tempPrdList.sort(function (a: any, b: any) { return -new Date(b.LaunchDT) - -new Date(a.LaunchDT) });

            this.WipCnt = tempCntWip.length
            this.overDueCnt = tempOverDueCnt.length
            this.TotalJob = tempPrdList.length
            this.oldestJob = oldestSort[0].JobNo
            this.maxLoad = unique[0] ? unique[0] : ''
          }


          let tempProjectList = cData.filter((a: any) => a.JobTypeID == 2);
          if (this.prTypeID == 2 && tempProjectList.length > 0) {
            let tempCntWip = tempProjectList.filter((x: any) => x.StageID > 0)
            let unique = [...new Set(tempCntWip.map((propYoureChecking: any) => propYoureChecking.Stage))];
            let tempOverDueCnt = tempProjectList.filter((x: any) => new Date(x.TargetDT) < new Date())
            let oldestSort = tempProjectList.sort(function (a: any, b: any) { return -new Date(b.LaunchDT) - -new Date(a.LaunchDT) });
            this.WipCnt = tempCntWip.length
            this.overDueCnt = tempOverDueCnt.length
            this.TotalJob = tempProjectList.length
            this.oldestJob = oldestSort[0].JobNo
            this.maxLoad = unique[0] ? unique[0] : ''
          }


          
          let tmpData: any = {};
          for (let i = 0; i < cData.length; i++) {

            if (cData[i].Generation) {

              let data = JSON.parse(cData[i].Generation)
              for (let x = 0; x < data.length; x++) {
                tmpData = {};
                tmpData = cData[i];
                let tempfilter = this.Items.filter((u: any) => u.ItemID == data[x].PID && data[x].PID != 0);
                if (tempfilter.length > 0) {
                  tmpData["ItemID"] = tempfilter[0].ItemID;
                  tmpData.ProductName = tempfilter[0].ItemName;
                  tmpData.ProductCode = tempfilter[0].ItemCode;
                  tmpData.Qty = Number(data[x].PQty) - ((data[x].GenQty ? Number(data[x].GenQty) : 0) + (data[x].RejQty ? Number(data[x].RejQty) : 0))  //tempfilter[0].CurrQty
                  tmpData.Qty = this.statusID == 2 ? (data[x].GenQty ? Number(data[x].GenQty) : 0) : tmpData.Qty;
                  tmpData.SKU = tempfilter[0].SKU
                }
                else {
                  tmpData.ProductName = '-'
                  tmpData.ProductCode = '-'
                  tmpData.Qty = 0
                  tmpData.SKU = '-'
                };

                let tempfil = this.billables.filter((u: any) => u.IID == data[x].PID && data[x].PID != 0);
                if (tempfil.length > 0) {
                  tmpData["ItemID"] = tempfil[0].IID;
                  tmpData.ProductName = tempfil[0].INm;
                  tmpData.ProductCode = tempfil[0].ICd;
                }
                else{
                  tmpData.ProductName = '-';
                  tmpData.ProductCode = '-';
                }
                this.ProductList.push(Object.assign({}, tmpData));

              }
            }
          }

          if(this.statusID == 2 && this.prTypeID == 1) {
            tnxnData.forEach((transaction: any) => {
              transaction.JobNo = transaction.XnNo;
              transaction.JobTypeID = 1;
              transaction.CstrRelName = transaction.RelContactName;
              transaction.LaunchDT = transaction.CreatedDT;
              transaction.TargetDT = transaction.CreatedDT;
              if (transaction.XnItems) {
                let data = JSON.parse(transaction.XnItems);
                for (let x = 0; x < data.length; x++) {
                  tmpData = {};
                  tmpData = transaction;
                  let tempfilter = this.Items.filter((u: any) => u.ItemID == data[x].IID);
                  if (tempfilter.length > 0) {
                    if(data[x].IQ != 0) {
                      tmpData["ItemID"] = tempfilter[0].ItemID;
                      tmpData.ProductName = tempfilter[0].ItemName;
                      tmpData.ProductCode = tempfilter[0].ItemCode;
                      tmpData.Qty = Number(data[x].IQ);
                      tmpData.JobQty = tmpData.Qty;
                      tmpData.SKU = tempfilter[0].SKU;
                      this.ProductList.push(Object.assign({}, tmpData));
                    }
                  }
                }
              }
            });
          }

          this.ProductList.forEach((p: any) => {
            if (p.Generation) {
              let tmpGen = JSON.parse(p.Generation);
              p.JobQty = tmpGen[0].PQty;
              p.JobQty = this.statusID == 2 ? p.Qty : p.JobQty;
            }
            // p.targetDate = new Date(p.TargetDT).customFormat("#DD#-#MMM#-#YYYY#");
            p.DoneDT = (p.CmplDT ? p.CmplDT : p.UpdatedDT);
          });

          let productionList = [];
          let tempProductionList = this.ProductList.filter((a: any) => a.JobTypeID == 1);
          if(this.prTypeID == 1 && tempProductionList.length > 0){
            productionList = tempProductionList;
          }
          let tempProjectLsit = this.ProductList.filter((a: any) => a.JobTypeID == 2);
          if(this.prTypeID == 2 && tempProjectLsit.length > 0){
            // productionList = tempProjectLsit;
            tempProjectList.forEach((project : any)=>{
                let userIds =project.UserIDs ? String(project.UserIDs).split(",") : [];
                let currUser = userIds.filter((x: any) => x == this.jarvisData[0].UserID);
                if(currUser.length > 0) {
                  productionList.push(project);
                }
            })
          }
        
          this.ProductList = productionList.sort((a: any, b: any) => a.JobNo.localeCompare(b.JobNo))

          this.tempProdList = this.ProductList;

          if (this.statusID == 2) {

            // this.ProductList = this.tempProdList.filter((a: any) => new Date(a.TargetDT).getMonth() + 1 == this.month && new Date(a.TargetDT).getFullYear() == this.year);

            this.dataSource.data = this.ProductList;
            this.exportToExcel = this.ProductList;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.matSort;

          }

          this.dataSource = new MatTableDataSource(this.ProductList);
          this.exportToExcel = this.ProductList;

        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    // this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }



  //common search
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  //common search Mobile view
  applyFilterMob(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  min_most_duplicate(arr: any) {
    var result: any = {},
      max = 0,
      res;

    arr = arr.slice(0); // make a copy of the array
    arr.sort(function (a: any, b: any) { return (a - b); }); // sort it numerically

    for (var i = 0, total = arr.length; i < total; ++i) {
      var val = arr[i],
        inc = (result[val] || 0) + 1;

      result[val] = inc;

      if (inc > max) {
        max = inc;
        res = val;
      }
    }

    return res;
  }


  getData() {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    let data = [{
      StatusID: this.statusID,
      StoreID: 0
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'get',
      moduleID: 5,
      data: JSON.stringify(data)
    }];
    this.SpinnerService.show();
    this.apiService.getData(myParams, this.successRespItem.bind(this), this.failureRespItem.bind(this));
  }

  //successResp - success  get handler
  successRespItem(res: any) {
    
    this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      if (res) {
       
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          let data = reponseData;

          let tempItems = data.Table1;
          this.Items = tempItems
          // this.apiService.setIDB('erp_inv', this.Items);

          this.getWIPNos()
        
        }
      }
    }
  }

  //failureResp - failure handler
  failureRespItem(res: any) {
   
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  //get Months and year perionds

  getPeriodData() {
    this.months = this.commonSer.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date().customFormat("#DD#-#MMM#-#YY#"));

    this.months.forEach(function (e: any) {
      e.number = Number(e.number);
    });
    return;
  }

  //pandding and history filter..
  jobFilter(id: number) {
    
    this.statusID = id;
    if (id == 2) {
      // this.month = this.curDate.getMonth() + 1;jo
      // this.year = this.curDate.getFullYear();
      // this.view.month = this.month;
      this.view.month = this.months[this.months.length - 1].id;
    }
    this.getData();
  }

  stockYearChange() {
    // let tempMonYr = this.months;
    let selecetdYear = this.months.filter((a: any) => a.id == this.view.month);
    this.year = selecetdYear[0].year;
    this.month = selecetdYear[0].number;
    this.getWIPNos();

    // this.ProductList = this.tempProdList.filter((a: any) => new Date(a.LaunchDT).getMonth() + 1 == this.month && new Date(a.LaunchDT).getFullYear() == this.year);
    // this.dataSource.data = this.ProductList;
    // this.exportToExcel = this.ProductList;
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.matSort;
  }

  backToHomeBtn() {
    window.location.href = "https://biziverse.com/main.html#/home";
  }

  exportToExcelActivities() {
    var html = "";
    //Title
    html += "<table><tr>";
    if (this.prTypeID == 1) {
      html += "<th style='text-align: left;'>Production Jobs</th>"
    }
    else{
      html += "<th style='text-align: left;'>Projects</th>"
    }
   
    html += "</table></tr>";

    html += "<table><tr></table></tr>";
    html += "<table><tr>";
    var view = ''
    var month = ''
    if (this.statusID == 1) {
      view = 'Pending'
      html += "<p><b>View : </b>" + view + "</p>"
    }
    else {
      let selecetdYear = this.months.filter((a: any) => a.id == this.view.month);
      view = 'History'
      month = selecetdYear.length > 0 ? selecetdYear[0].display : ''
      html += "<p><b>View : </b>" + view + ', ' + "<b>Month : </b>" + month + "</p>"
    }

    html += "</table></tr>";

    html += "<table><tr>";
    var strHeader = ""
    strHeader += "<th style='text-align: left;'>" + (this.prTypeID == 1 ? 'WIP No.': 'Project') + "</th>";
    strHeader += "<th style='text-align: left;'>Product</th>";
    strHeader += "<th style='text-align: left;'>Code</th>";
    strHeader += "<th style='text-align: left;'>Customer</th>";
    strHeader += "<th style='text-align: left;'>Launch</th>";
    strHeader += "<th style='text-align: left;'>Target</th>";
    if (this.prTypeID == 1) {
      strHeader += "<th style='text-align: right; '>Qty</th>";
      strHeader += "<th style='text-align: left;'>Unit</th>";
    }
    strHeader += "<th style='text-align: left;'>Stage</th>";



    strHeader += "</tr>"
    html += strHeader;
    var body = "";
    this.exportToExcel.forEach((item: any, key: any) => {
      body += "<tr>";
      body += "<td style='text-align: left;'>" + item.JobNo + "</td>";
      body += "<td style='text-align: left;'>" + item.ProductName + "</td>";
      body += "<td style='text-align: left;'>" + item.ProductCode + "</td>";
      body += "<td style='text-align: left;'>" + item.CstrRelName + "</td>";
      item.LaunchDT = (item.LaunchDT == null) ? '-' : new Date(item.LaunchDT).customFormat("#DD#-#MMM#-#YYYY#");
      body += "<td style='text-align: left;'>" + item.LaunchDT + "</td>";
      item.targetDate = (item.targetDate == null) ? '-' : new Date(item.targetDate).customFormat("#DD#-#MMM#-#YYYY#");
      body += "<td style='text-align: left;'>" + item.targetDate + "</td>";
      if (this.prTypeID == 1) {
        body += "<td style='text-align: right;'>" + (item.Qty < 0 ? '0' : item.Qty) + "</td>";
        body += "<td style='text-align: left;'>" + item.SKU + "</td>";
      }
      body += "<td style='text-align: left;'>" + (item.Stage ? item.Stage : '-') + "</td>";
      body += "</tr>";
    })
    html += body;
    html += "</table>";
    if (this.prTypeID == 1) {
      this.tableToExcel(html, 'Sheet1', 'Production Jobs');
    }
    else{
      this.tableToExcel(html, 'Sheet1', 'Project');
    }
   
  }
;
  JobCardPrint(jobID: number, ItemID: number){
    if(this.prTypeID == 2){
      window.open('ProjectTracker?JobID=' + jobID + "&IID=" + ItemID , '_blank', 'Height= 600px, Width= 900px, Top= 50px, edge= Raised, center= Yes, help= No, status= No');
    }
    else{
      window.open('jobcardPrint?JobID=' + jobID + "&IID=" + ItemID , '_blank', 'Height= 600px, Width= 900px, Top= 50px, edge= Raised, center= Yes, help= No, status= No');
    }
 } 

  // Open Help Page
  openHelpPage(id: any) {
    this.commonFun.openModulHelp(id, this.isWeb);
  }

  openEntryModal() {
    if(this.prTypeID == 2){
      let url = '';
      if (this.apiService.fn_isLiveURL() == true)
      {
        url = "https://biziverse.com/ERP/ProjectTypes?o=1";
      }
      else{
        url = "http://localhost:4200/ProjectTypes?o=1";
      } 
      window.open(url, '_blank');
    }
    else{
      this.modalReference = this.modalService.open(ItemEntryComponent, { windowClass: 'WebModalItemsEntry', backdrop: 'static', keyboard: false });
      this.modalReference.componentInstance.mdlRef = this.modalReference;
      this.modalReference.result.then((result: any) => {})
    }
  }

  comingSoon() {
    this.apiService.successAlert("Coming soon.");
  }

  openTrngModal = () => {
    this.dataSer.trainingVideoActions('active', 13);
    this.modalReference = this.modalService.open(ModuleTrainingComponent, { windowClass: "modal-suggest-profile", backdrop: 'static', keyboard: false });
  }
  //Print Data
  printTranjection(id: number){
    var XnID: string = this.commonSer.encryptData(id);
    let AgencyID: string = this.commonSer.encryptData(this.jarvisData[0].AgencyIDs);
    window.open('BasicPrdPrint?XnID=' + XnID + "&aid=" + AgencyID, '_blank', 'Height= 800px, Width= 1000px, padding:10px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
    // http://localhost:4200/BasicPrdPrint?XnID=JIHMHH&aid=IKNLB
  }
 
}


//end
declare global {
  interface Date {
    customFormat(formatString: any): string;
  }
}

// String Prototye
Date.prototype.customFormat = function (formatString: any) {
  var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhhh, hhh, hh, h, mm, m, ss, s, ampm, AMPM, dMod, th;
  YY = ((YYYY = this.getFullYear()) + "").slice(-2);
  MM = (M = this.getMonth() + 1) < 10 ? ('0' + M) : M;
  MMM = (MMMM = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][M - 1]).substring(0, 3);
  DD = (D = this.getDate()) < 10 ? ('0' + D) : D;
  DDD = (DDDD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][this.getDay()]).substring(0, 3);
  th = (D >= 10 && D <= 20) ? 'th' : ((dMod = D % 10) == 1) ? 'st' : (dMod == 2) ? 'nd' : (dMod == 3) ? 'rd' : 'th';
  formatString = formatString.replace("#YYYY#", YYYY).replace("#YY#", YY).replace("#MMMM#", MMMM).replace("#MMM#", MMM).replace("#MM#", MM).replace("#M#", M).replace("#DDDD#", DDDD).replace("#DDD#", DDD).replace("#DD#", DD).replace("#D#", D).replace("#th#", th);
  h = (hhh = this.getHours());
  if (h == 0) h = 24;
  if (h > 12) h -= 12;
  hh = h < 10 ? ('0' + h) : h;
  hhhh = h < 10 ? ('0' + hhh) : hhh;
  AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
  mm = (m = this.getMinutes()) < 10 ? ('0' + m) : m;
  ss = (s = this.getSeconds()) < 10 ? ('0' + s) : s;
  return formatString.replace("#hhhh#", hhhh).replace("#hhh#", hhh).replace("#hh#", hh).replace("#h#", h).replace("#mm#", mm).replace("#m#", m).replace("#ss#", ss).replace("#s#", s).replace("#ampm#", ampm).replace("#AMPM#", AMPM);
}

